import type { MovementRawRow } from "../types/inventoryMovement"

/** Sumber: HTML referensi `inventory_movement_stock_card_control_report.html` */
export const DUMMY_MOVEMENT_RAW: MovementRawRow[] = [
  {
    date: "2026-05-01",
    transactionType: "Opening Balance",
    reference: "OB-202605-0001",
    location: "Main Warehouse",
    stockIn: 120,
    stockOut: 0,
    actualClosing: 120,
    cost: 88000,
    createdBy: "System",
    note: "Opening stock for May"
  },
  {
    date: "2026-05-02",
    transactionType: "Sales Issue",
    reference: "SO-202605-0007",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 5,
    actualClosing: 115,
    cost: 88000,
    createdBy: "Dewi",
    note: "Retail sales issue"
  },
  {
    date: "2026-05-03",
    transactionType: "Stock Transfer",
    reference: "TRF-202605-0003",
    location: "Retail Store",
    stockIn: 20,
    stockOut: 0,
    actualClosing: 135,
    cost: 88500,
    createdBy: "Komang",
    note: "Transfer from main warehouse"
  },
  {
    date: "2026-05-04",
    transactionType: "Sales Issue",
    reference: "SO-202605-0012",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 7,
    actualClosing: 128,
    cost: 88500,
    createdBy: "Ayu",
    note: "Customer sales"
  },
  {
    date: "2026-05-05",
    transactionType: "Purchase Receive",
    reference: "GRN-202605-0005",
    location: "Main Warehouse",
    stockIn: 35,
    stockOut: 0,
    actualClosing: 163,
    cost: 90000,
    createdBy: "Gusti",
    note: "Supplier delivery received"
  },
  {
    date: "2026-05-06",
    transactionType: "Goods Request",
    reference: "GR-202605-0011",
    location: "Resort Store",
    stockIn: 0,
    stockOut: 4,
    actualClosing: 159,
    cost: 90000,
    createdBy: "Risda",
    note: "Villa display requirement"
  },
  {
    date: "2026-05-07",
    transactionType: "Sales Issue",
    reference: "SO-202605-0021",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 6,
    actualClosing: 153,
    cost: 90000,
    createdBy: "Dewi",
    note: "Retail sales"
  },
  {
    date: "2026-05-08",
    transactionType: "Stock Adjustment",
    reference: "ADJ-202605-0002",
    location: "Main Warehouse",
    stockIn: 0,
    stockOut: 2,
    actualClosing: 151,
    cost: 90000,
    createdBy: "Inventory Control",
    note: "Damaged item adjustment"
  },
  {
    date: "2026-05-09",
    transactionType: "Sales Issue",
    reference: "SO-202605-0029",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 8,
    actualClosing: 143,
    cost: 90000,
    createdBy: "Ayu",
    note: "Retail sales"
  },
  {
    date: "2026-05-10",
    transactionType: "Stock Transfer",
    reference: "TRF-202605-0008",
    location: "Project Site",
    stockIn: 12,
    stockOut: 0,
    actualClosing: 155,
    cost: 90000,
    createdBy: "Logistic",
    note: "Project staging sample"
  },
  {
    date: "2026-05-11",
    transactionType: "Build Item",
    reference: "BOM-202605-0004",
    location: "Production",
    stockIn: 16,
    stockOut: 0,
    actualClosing: 171,
    cost: 90500,
    createdBy: "Production",
    note: "Finished cushion assembly"
  },
  {
    date: "2026-05-12",
    transactionType: "Sales Issue",
    reference: "SO-202605-0033",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 9,
    actualClosing: 162,
    cost: 90500,
    createdBy: "Dewi",
    note: "Retail sales"
  },
  {
    date: "2026-05-13",
    transactionType: "Goods Request",
    reference: "GR-202605-0019",
    location: "Resort Store",
    stockIn: 0,
    stockOut: 5,
    actualClosing: 157,
    cost: 90500,
    createdBy: "Risda",
    note: "Villa replacement stock"
  },
  {
    date: "2026-05-14",
    transactionType: "Purchase Receive",
    reference: "GRN-202605-0012",
    location: "Main Warehouse",
    stockIn: 24,
    stockOut: 0,
    actualClosing: 181,
    cost: 91000,
    createdBy: "Gusti",
    note: "Supplier receive"
  },
  {
    date: "2026-05-15",
    transactionType: "Sales Issue",
    reference: "SO-202605-0042",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 12,
    actualClosing: 169,
    cost: 91000,
    createdBy: "Komang",
    note: "Retail sales"
  },
  {
    date: "2026-05-16",
    transactionType: "Stock Count",
    reference: "CNT-202605-0001",
    location: "Main Warehouse",
    stockIn: 0,
    stockOut: 1,
    actualClosing: 168,
    cost: 91000,
    createdBy: "Inventory Control",
    note: "Physical count variance"
  },
  {
    date: "2026-05-17",
    transactionType: "Sales Issue",
    reference: "SO-202605-0048",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 11,
    actualClosing: 157,
    cost: 91000,
    createdBy: "Ayu",
    note: "Retail sales"
  },
  {
    date: "2026-05-18",
    transactionType: "Stock Transfer",
    reference: "TRF-202605-0014",
    location: "Retail Store",
    stockIn: 30,
    stockOut: 0,
    actualClosing: 187,
    cost: 91000,
    createdBy: "Logistic",
    note: "Replenishment to store"
  },
  {
    date: "2026-05-19",
    transactionType: "Sales Issue",
    reference: "SO-202605-0055",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 13,
    actualClosing: 174,
    cost: 91000,
    createdBy: "Dewi",
    note: "Retail sales"
  },
  {
    date: "2026-05-20",
    transactionType: "Goods Request",
    reference: "GR-202605-0027",
    location: "Resort Store",
    stockIn: 0,
    stockOut: 6,
    actualClosing: 168,
    cost: 91000,
    createdBy: "Risda",
    note: "Guest room setup"
  },
  {
    date: "2026-05-21",
    transactionType: "Build Item",
    reference: "BOM-202605-0010",
    location: "Production",
    stockIn: 18,
    stockOut: 0,
    actualClosing: 186,
    cost: 90666,
    createdBy: "Production",
    note: "New finished item build"
  },
  {
    date: "2026-05-22",
    transactionType: "Sales Issue",
    reference: "SO-202605-0060",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 15,
    actualClosing: 171,
    cost: 90666,
    createdBy: "Komang",
    note: "Retail sales"
  },
  {
    date: "2026-05-23",
    transactionType: "Stock Adjustment",
    reference: "ADJ-202605-0008",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 3,
    actualClosing: 168,
    cost: 90666,
    createdBy: "Inventory Control",
    note: "Display damage"
  },
  {
    date: "2026-05-24",
    transactionType: "Sales Issue",
    reference: "SO-202605-0069",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 14,
    actualClosing: 154,
    cost: 90666,
    createdBy: "Ayu",
    note: "Retail sales"
  },
  {
    date: "2026-05-25",
    transactionType: "Purchase Receive",
    reference: "GRN-202605-0019",
    location: "Main Warehouse",
    stockIn: 40,
    stockOut: 0,
    actualClosing: 194,
    cost: 90666,
    createdBy: "Gusti",
    note: "Supplier delivery"
  },
  {
    date: "2026-05-26",
    transactionType: "Stock Transfer",
    reference: "TRF-202605-0021",
    location: "Retail Store",
    stockIn: 25,
    stockOut: 0,
    actualClosing: 219,
    cost: 90666,
    createdBy: "Logistic",
    note: "Store replenishment"
  },
  {
    date: "2026-05-27",
    transactionType: "Sales Issue",
    reference: "SO-202605-0075",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 18,
    actualClosing: 201,
    cost: 90666,
    createdBy: "Dewi",
    note: "Retail sales"
  },
  {
    date: "2026-05-28",
    transactionType: "Goods Request",
    reference: "GR-202605-0032",
    location: "Resort Store",
    stockIn: 0,
    stockOut: 7,
    actualClosing: 194,
    cost: 90666,
    createdBy: "Risda",
    note: "Villa display usage"
  },
  {
    date: "2026-05-29",
    transactionType: "Sales Issue",
    reference: "SO-202605-0084",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 22,
    actualClosing: 172,
    cost: 90666,
    createdBy: "Komang",
    note: "Retail sales"
  },
  {
    date: "2026-05-30",
    transactionType: "Stock Count",
    reference: "CNT-202605-0003",
    location: "Main Warehouse",
    stockIn: 0,
    stockOut: 2,
    actualClosing: 169,
    cost: 90666,
    createdBy: "Inventory Control",
    note: "Monthly stock count - intentional variance sample"
  },
  {
    date: "2026-05-31",
    transactionType: "Sales Issue",
    reference: "SO-202605-0091",
    location: "Retail Store",
    stockIn: 0,
    stockOut: 90,
    actualClosing: 80,
    cost: 90666,
    createdBy: "Ayu",
    note: "Month end sales issue"
  }
]
